/**
 * This file provides a mapping interface to Luisa theme colors and spacings.
 */

const swatches: Record<string, Record<string, string>> = {
    leadblue: {
        100: '#432eea',
    },
    devblue: {
        100: '#1e156a',
        95: '#2a208a',
        90: '#4f53af',
        60: '#91a3e1',
        30: '#bdcdf4',
        10: '#e4e6f9',
    },
    headset: {
        100: '#246df7',
        60: '#7ba7fa',
        30: '#b9d0fc',
        10: '#e9f0fe',
    },
    gray: {
        100: '#3c3c3c',
        90: '#666666',
        60: '#9a9ba2',
        30: '#d2d6de',
        10: '#f1f2f6',
    },
    green: {
        100: '#2b7f5b',
        60: '#47bd76',
        30: '#6bcf93',
        20: '#abe1c3',
        10: '#c4e9d3',
    },
    yellow: {
        100: '#d4b483',
        60: '#ffc24e',
        30: '#fce7ad',
        10: '#fff3d2',
    },
    red: {
        100: '#c7303e',
        90: '#f72438',
        60: '#ee7884',
        30: '#f9b9c1',
        10: '#edbcc1',
    },
    pink: {
        100: '#eb4b98',
        60: '#f393c1',
        10: '#fdedf4',
    },
    white: {
        100: '#fefefe',
    },
    background: {
        100: '#0B0826',
        10: '#e8ebf4',
    },
};

const spacings = {
    '4xs': 0.25,
    '3xs': 0.5,
    '2xs': 0.75,
    xs: 1,
    sm: 1.25,
    md: 1.5,
    lg: 2,
    xl: 2.5,
    '2xl': 3,
    '3xl': 3.5,
    '4xl': 4,
    '5xl': 5,
};

const shadows = [
    'none',
    `0 0.01rem 0.01rem rgba(0, 0, 0, 0.1), 
     0 0.02rem 0.02rem rgba(0, 0, 0, 0.1), 
     0 0.03rem 0.04rem rgba(0, 0, 0, 0.1), 
     0 0.04rem 0.08rem rgba(0, 0, 0, 0.1), 
     0 0.05rem 0.16rem rgba(0, 0, 0, 0.1)`,
    `0 0.04rem 0.04rem rgba(0, 0, 0, 0.1), 
     0 0.08rem 0.08rem rgba(0, 0, 0, 0.1), 
     0 0.12rem 0.16rem rgba(0, 0, 0, 0.1), 
     0 0.16rem 0.32rem rgba(0, 0, 0, 0.1), 
     0 0.2rem 0.64rem rgba(0, 0, 0, 0.1)`,
    `0 0.09rem 0.09rem rgba(0, 0, 0, 0.1), 
     0 0.18rem 0.18rem rgba(0, 0, 0, 0.1), 
     0 0.27rem 0.36rem rgba(0, 0, 0, 0.1), 
     0 0.36rem 0.72rem rgba(0, 0, 0, 0.1), 
     0 0.45rem 1.44rem rgba(0, 0, 0, 0.1)`,
];

const luisa = {
    /**
     * Getter for Luisa's color swatches.
     * Usage: luisa.swatch('devblue', '100')
     *
     * @param palette - The palette of the color to get.
     * @param shade - The shade of the color to get.
     * @returns The color value.
     */
    swatch: (palette: string, shade: string): string => {
        if (swatches[palette] && swatches[palette][shade]) {
            return swatches[palette][shade];
        }

        return '#000000';
    },
    swatches,
    spacings,
    shadows,
};

export default luisa;
